import Vue from "vue";
import VueRouter from "vue-router";
import BindBatch from "../clerks/bind_batch.vue";
import ClerkApplication from "../clerk_application.vue";

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        { path: "/", name: "ClerkApplication", component: ClerkApplication },
        { path: "/bind_batch/:id", name: "BindBatch", component: BindBatch },
    ],
});

export default router;
